import { combineReducers } from 'redux'
import profileReducer from './reducers/profile'
import jobReducer from './reducers/job'
import documentReducer from './reducers/document'

export default combineReducers({ 
    profile: profileReducer,
    job: jobReducer,
    document: documentReducer,
})